export const checkIfEdited = <T extends Object>(
  defaultDataObject: T,
  newDataObject: T,
) =>
  Object.keys(newDataObject).find(
    (edkey) =>
      defaultDataObject[edkey as keyof T] !== newDataObject[edkey as keyof T],
  )
    ? true
    : false;
